// extracted by mini-css-extract-plugin
export var box = "_7a-1";
export var checkboxRow = "_7a-8";
export var checked = "_7a-2";
export var descriptionSpacer = "_7a-a";
export var disabled = "_7a-3";
export var icon = "_7a-6";
export var input = "_7a-0";
export var labelSpacer = "_7a-9";
export var medium = "_7a-5";
export var small = "_7a-4";
export var text = "_7a-7";